import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { Grid, Typography } from '@material-ui/core';

import Loading from 'Console/components/common/loading/Loading';
import FormInput from 'Console/components/common/form/FormInput';
import FormColorPicker from 'Console/components/common/form/FormColorPicker';

import {
    selectThemeSchemasData,
    selectThemeSchemasIsLoading,
} from 'Console/data/applicationDetail/themes/selectors';

const styles = (theme) => ({
    root: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        [theme.breakpoints.down('lg')]: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
        },
    },
    formName: {
        marginRight: theme.typography.pxToRem(40),
    },
    sections: {
        width: '45%',
        paddingBottom: theme.typography.pxToRem(20),
    },
    sectionName: {
        fontWeight: 'bold',
        paddingBottom: theme.typography.pxToRem(20),
    },
    items: {
        paddingBottom: theme.typography.pxToRem(20),
        alignItems: 'center',
        justifyContent: 'space-between',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            alignItems: 'flex-start',
            'margin-right': 0,
            paddingBottom: 0,
        },
    },
    formBox: {
        padding: '5%',
    },
    formInput: {
        width: '42%',
    },
});

class EditTheme extends Component {
    handleChangeColor = (key) => (color) => {
        const {
            form: { setFieldsValue },
        } = this.props;

        setFieldsValue({
            [key]: `rgba(${color.rgb.r}, ${color.rgb.g}, ${color.rgb.b}, ${color.rgb.a})`,
        });
    };

    render() {
        const {
            editThemeId,
            form,
            classes,
            intl,
            form: { getFieldDecorator },
            themeSchemasData,
            themeSchemasIsLoading,
        } = this.props;

        if (themeSchemasIsLoading) {
            return <Loading minHeight="300" />;
        }

        const editTheme = themeSchemasData[editThemeId];

        if (!editTheme) {
            return (
                <Grid className={classes.root}>
                    <Grid container direction="row" alignItems="center" justify="center">
                        <Typography className={classes.formName} variant="body1">
                            {intl.formatMessage({ id: 'Theme.edit.error' })}
                        </Typography>
                    </Grid>
                </Grid>
            );
        }

        getFieldDecorator('backgroundPrimaryColor', {
            initialValue: editTheme.schema.backgroundPrimaryColor,
        });

        getFieldDecorator('backgroundSecondaryColor', {
            initialValue: editTheme.schema.backgroundSecondaryColor,
        });

        getFieldDecorator('fontColor', {
            initialValue: editTheme.schema.fontColor,
        });

        getFieldDecorator('titleColor', {
            initialValue: editTheme.schema.titleColor,
        });
        getFieldDecorator('navigationPrimaryColor', {
            initialValue: editTheme.schema.navigationPrimaryColor,
        });
        getFieldDecorator('navigationSecondaryColor', {
            initialValue: editTheme.schema.navigationSecondaryColor,
        });
        getFieldDecorator('shadowColor', {
            initialValue: editTheme.schema.shadowColor,
        });

        return (
            <Grid className={classes.root}>
                <Grid container direction="row" alignItems="center" justify="center">
                    <Typography className={classes.formName} variant="body1">
                        {intl.formatMessage({ id: 'Theme.edit.name' })}
                    </Typography>

                    <Grid className={classes.formInput}>
                        <FormInput
                            isRequired
                            fullWidth={false}
                            form={form}
                            type="text"
                            formItemKey="name"
                            placeholder={intl.formatMessage({ id: 'Theme.edit.name.placeholder' })}
                            editThemeId={editThemeId}
                            initialValue={editTheme.name}
                        />
                    </Grid>
                </Grid>

                <Grid className={classes.formBox}>
                    <Grid container direction="row" justify="space-between" alignItems="flex-start">
                        <Grid container direction="column" justify="center" className={classes.sections}>
                            <Grid item>
                                <Typography className={classes.sectionName} variant="body1">
                                    {intl.formatMessage({ id: 'Theme.edit.background' })}
                                </Typography>
                            </Grid>

                            <Grid
                                container
                                direction="row"
                                alignItems="center"
                                className={classes.items}
                            >
                                <Typography className={classes.formName} variant="body1">
                                    {intl.formatMessage({ id: 'Theme.edit.primaryColor' })}
                                </Typography>

                                <FormColorPicker
                                    onChange={this.handleChangeColor('backgroundPrimaryColor')}
                                    initialValue={editTheme.schema.backgroundPrimaryColor}
                                />
                            </Grid>

                            <Grid
                                container
                                direction="row"
                                alignItems="center"
                                className={classes.items}
                            >
                                <Typography className={classes.formName} variant="body1">
                                    {intl.formatMessage({ id: 'Theme.edit.secondaryColor' })}
                                </Typography>

                                <FormColorPicker
                                    onChange={this.handleChangeColor('backgroundSecondaryColor')}
                                    initialValue={editTheme.schema.backgroundSecondaryColor}
                                />
                            </Grid>

                            <Grid
                                container
                                direction="row"
                                alignItems="center"
                                className={classes.items}
                            >
                                <Typography className={classes.formName} variant="body1">
                                    {intl.formatMessage({ id: 'Theme.edit.imageAddress' })}
                                </Typography>

                                <FormInput
                                    fullWidth={false}
                                    form={form}
                                    type="text"
                                    formItemKey="imageAddress"
                                    placeholder="images/themes/yeself/logo-black.png"
                                    initialValue={editTheme.schema.imageAddress}
                                />
                            </Grid>
                        </Grid>

                        <Grid container direction="column" justify="center" className={classes.sections}>
                            <Grid item>
                                <Typography className={classes.sectionName} variant="body1">
                                    {intl.formatMessage({ id: 'Theme.edit.font' })}
                                </Typography>
                            </Grid>

                            <Grid
                                container
                                direction="row"
                                alignItems="center"
                                className={classes.items}
                            >
                                <Typography className={classes.formName} variant="body1">
                                    {intl.formatMessage({ id: 'Theme.edit.fontColor' })}
                                </Typography>

                                <FormColorPicker
                                    popupStyles={{ right: '30px' }}
                                    onChange={this.handleChangeColor('fontColor')}
                                    initialValue={editTheme.schema.fontColor}
                                />
                            </Grid>

                            <Grid
                                container
                                direction="row"
                                alignItems="center"
                                className={classes.items}
                            >
                                <Typography className={classes.formName} variant="body1">
                                    {intl.formatMessage({ id: 'Theme.edit.titleColor' })}
                                </Typography>

                                <FormColorPicker
                                    popupStyles={{ right: '30px' }}
                                    onChange={this.handleChangeColor('titleColor')}
                                    initialValue={editTheme.schema.titleColor}
                                />
                            </Grid>

                            <Grid
                                container
                                direction="row"
                                alignItems="center"
                                className={classes.items}
                            >
                                <Typography className={classes.formName} variant="body1">
                                    {intl.formatMessage({ id: 'Theme.edit.fontFamily' })}
                                </Typography>

                                <FormInput
                                    isRequired
                                    fullWidth={false}
                                    form={form}
                                    type="text"
                                    formItemKey="fontFamily"
                                    placeholder="Sofia Pro"
                                    initialValue={editTheme.schema.fontFamily}
                                />
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid container direction="row" justify="space-between" alignItems="flex-start">
                        <Grid container direction="column" justify="center" className={classes.sections}>
                            <Grid item>
                                <Typography className={classes.sectionName} variant="body1">
                                    {intl.formatMessage({ id: 'Theme.edit.navigation' })}
                                </Typography>
                            </Grid>

                            <Grid
                                container
                                direction="row"
                                alignItems="center"
                                className={classes.items}
                            >
                                <Typography className={classes.formName} variant="body1">
                                    {intl.formatMessage({ id: 'Theme.edit.navigation.primaryColor' })}
                                </Typography>

                                <FormColorPicker
                                    onChange={this.handleChangeColor('navigationPrimaryColor')}
                                    initialValue={editTheme.schema.navigationPrimaryColor}
                                />
                            </Grid>

                            <Grid
                                container
                                direction="row"
                                alignItems="center"
                                className={classes.items}
                            >
                                <Typography className={classes.formName} variant="body1">
                                    {intl.formatMessage({ id: 'Theme.edit.navigation.secondaryColor' })}
                                </Typography>

                                <FormColorPicker
                                    onChange={this.handleChangeColor('navigationSecondaryColor')}
                                    initialValue={editTheme.schema.navigationSecondaryColor}
                                />
                            </Grid>
                        </Grid>

                        <Grid container direction="column" justify="center" className={classes.sections}>
                            <Grid item>
                                <Typography className={classes.sectionName} variant="body1">
                                    {intl.formatMessage({ id: 'Theme.edit.shadow' })}
                                </Typography>
                            </Grid>

                            <Grid
                                container
                                direction="row"
                                alignItems="center"
                                className={classes.items}
                            >
                                <Typography className={classes.formName} variant="body1">
                                    {intl.formatMessage({ id: 'Theme.edit.color' })}
                                </Typography>

                                <FormColorPicker
                                    popupStyles={{ right: '30px' }}
                                    onChange={this.handleChangeColor('shadowColor')}
                                    initialValue={editTheme.schema.shadowColor}
                                />
                            </Grid>

                            <Grid
                                container
                                direction="row"
                                alignItems="center"
                                className={classes.items}
                            >
                                <Typography className={classes.formName} variant="body1">
                                    {intl.formatMessage({ id: 'Theme.edit.shadow.depth' })}
                                </Typography>

                                <FormInput
                                    fullWidth={false}
                                    form={form}
                                    type="number"
                                    formItemKey="shadowDepth"
                                    placeholder="49999"
                                    initialValue={editTheme.schema.shadowDepth}
                                />
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid container direction="row" justify="space-between" alignItems="flex-start">
                        <Grid container direction="column" justify="center" className={classes.sections}>
                            <Grid item>
                                <Typography className={classes.sectionName} variant="body1">
                                    {intl.formatMessage({ id: 'Theme.edit.step' })}
                                </Typography>
                            </Grid>

                            <Grid
                                container
                                direction="row"
                                alignItems="center"
                                className={classes.items}
                            >
                                <Typography className={classes.formName} variant="body1">
                                    {intl.formatMessage({ id: 'Theme.edit.depth' })}
                                </Typography>

                                <FormInput
                                    fullWidth={false}
                                    form={form}
                                    type="number"
                                    formItemKey="stepDepth"
                                    placeholder="29999"
                                    initialValue={editTheme.schema.stepDepth}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    }
}
export default connect(
    (state) => ({
        themeSchemasData: selectThemeSchemasData(state),
        themeSchemasIsLoading: selectThemeSchemasIsLoading(state),
    }),
    {}
)(withStyles(styles)(injectIntl(EditTheme)));
